export enum AnnouncementTemplateType {
  Template1 = "template1"
}

export interface AnnouncementTemplate1 {
  title: string;
  description: string;
  image_url: string;
  action_button: {
    label: string;
    actions: AnnouncementAction[];
  };
}

export type AnnouncementTemplateMetadata = AnnouncementTemplate1;

export enum AnnouncementActionType {
  Navigate = "navigate",
  Click = "click",
  ExternalLink = "external_link"
}

export interface AnnouncementAction {
  type: AnnouncementActionType;
  value: string;
}

export interface Announcement {
  id: string;
  name: string;
  template_type: AnnouncementTemplateType;
  template_metadata: AnnouncementTemplateMetadata;
  interactions_count: number;
  modal_size?: "sm" | "md" | "lg";
}

export enum AnnouncementUserInteraction {
  DISMISSED = "dismissed",
  REMIND_LATER = "remind_later",
  VIEWED = "viewed"
}

export interface AnnouncementsResponse {
  data: Announcement[];
}

export interface AnnouncementUserInteractionRequest {
  announcement_id: string;
  action: AnnouncementUserInteraction;
}
